import React from 'react'
import TagInput from '../TagInput/TagInput'
import styles from './TagFilter.module.scss'

export interface TagFilterProps {
  value: string[]
  onChange: (next: string[]) => void
  label?: string
  suggestions?: string[]
}

export default function TagFilter({ value, onChange, label = 'Filtrer par tag', suggestions }: TagFilterProps) {
  return (
    <div className={styles.filterContainer}>
      <span className={styles.filterLabel}>{label}</span>
      <div className={styles.filterInput}>
        <TagInput value={value} onChange={onChange} placeholder="Ajouter un tag au filtre…" suggestions={suggestions} />
      </div>
      {value.length > 0 && (
        <button
          type="button"
          className={styles.clearBtn}
          onClick={() => onChange([])}
        >
          Effacer
        </button>
      )}
    </div>
  )
}
